import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ToolboxScaleNsk = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M21.6 3.00002C21.6 2.66862 21.3314 2.40002 21 2.40002H16.8L21.6 7.20002V3.00002Z"
        fill={color}
      />
      <path
        d="M18.1375 3.73888L15.7389 6.1402L17.8623 8.26127L20.2609 5.85995L18.1375 3.73888Z"
        fill={color}
      />
      <path
        d="M2.4 21C2.4 21.3314 2.6686 21.6 3 21.6H7.2L2.4 16.8V21Z"
        fill={color}
      />
      <path
        d="M6.14003 15.7389L3.73872 18.1376L5.85979 20.261L8.2611 17.8623L6.14003 15.7389Z"
        fill={color}
      />
      <path
        d="M3 2.40002C2.6686 2.40002 2.4 2.66862 2.4 3.00002V7.20002L7.2 2.40002H3Z"
        fill={color}
      />
      <path
        d="M5.86054 3.73937L3.73943 5.86047L6.13942 8.26046L8.26053 6.13936L5.86054 3.73937Z"
        fill={color}
      />
      <path
        d="M21 21.6C21.3314 21.6 21.6 21.3314 21.6 21V16.8L16.8 21.6H21Z"
        fill={color}
      />
      <path
        d="M17.8617 15.7383L15.7383 17.8617L18.1383 20.2617L20.2617 18.1382L17.8617 15.7383Z"
        fill={color}
      />
      <path
        d="M12 2.70001V4.50001C16.1344 4.50001 19.5 7.86441 19.5 12H21.3C21.3 6.87191 17.1281 2.70001 12 2.70001Z"
        fill={color}
      />
      <path
        d="M4.5 12H2.7C2.7 17.1281 6.8719 21.3 12 21.3V19.5C7.8644 19.5 4.5 16.1344 4.5 12Z"
        fill={color}
      />
      <path
        d="M19.5 12C19.5 16.1344 16.1344 19.5 12 19.5V21.3C17.1281 21.3 21.3 17.1281 21.3 12H19.5Z"
        fill={color}
      />
      <path
        d="M2.7 12H4.5C4.5 7.86441 7.8644 4.50001 12 4.50001V2.70001C6.8719 2.70001 2.7 6.87191 2.7 12Z"
        fill={color}
      />
      <path
        d="M13.6769 11.5507C13.139 9.54309 13.2424 7.36359 13.2424 7.36359C13.2424 7.36359 12.2422 9.30279 10.7725 10.7725C9.3028 12.2422 7.3636 13.2424 7.3636 13.2424C7.3636 13.2424 9.5431 13.139 11.5507 13.6769C13.5583 14.2149 15.3941 15.3942 15.3941 15.3942C15.3941 15.3942 14.2149 13.5583 13.6769 11.5507Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ToolboxScaleNsk.displayName = 'ToolboxScaleNsk';
